export enum IndicationType {
  Unset = 0,
  StudyModelSmileDesign = 1,
  AlignerRetainerModel = 2,
  RemovableDieModel = 3,
  ModelCustomBleachingTray = 4,
  OcclusalGuard = 5,
  SurgicalGuide = 6,
  TryInDenture = 7,
  DentureBase = 8,
  HybridDenture = 9,
  DentureTeeth = 10,
  Crown = 11,
  Castable = 12,
  GingivaMask = 13,
  InlayAndOnlay = 14,
  IndirectBondingTray = 15,
  CustomImpressionTray = 16,
  Bridge = 17,
  SmileDesignSnapOn = 18,
  Veneer = 19,
  ImplantCrown = 20,
  Retainer = 21,
  AnteriorCrown = 22,
  Scan = 24,
  Restorations = 25,

  Upperscan = 101,
  Lowerscan = 102,
  Die = 103,
}
